<template>
    <div class="home-plan">
        <div class="plan-title">全面、专业、智能的解决方案</div>
        <div class="plan-more" @click="moreNews">查看全部解决方案 <i class="el-icon-arrow-right"></i></div>
        <div class="plan-content">
            <div class="plan-item" v-for="item in planList" :key="item.name">
                <div class="name">{{ item.name }}</div>
                <div class="text">{{ item.text }}</div>
                <div class="detail" @click="$router.push(item.path)">了解详情</div>
                <img :src="item.icon" />
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            // planList: [
            //     {
            //         name: '生产数据可视化应用',
            //         text: '实时展示生产数据，可视化界面',
            //         icon: require("@/assets/images/website/home/img1.png"),
            //         path:'/solution/digital-factory'
            //     },
            //     {
            //         name: '智能生产管控系统',
            //         text: '生产、排产、排程、协同',
            //         icon: require("@/assets/images/website/home/img2.png"),
            //         path:'/solution/intelligent-factory'
            //     },
            //     {
            //         name: '光学表面检测系统',
            //         text: '通过光学传感器检测板带箔表面平整度',
            //         icon: require("@/assets/images/website/home/img3.png"),
            //         path:'/solution/machine-vision'
            //     },
            //     {
            //         name: '有色金属加工质量管控系统',
            //         text: '有色金属加工质量管控，保证产品质量',
            //         icon: require("@/assets/images/website/home/img4.png"),
            //         path:'/solution/information-system'
            //     },
            //     {
            //         name: '边部加热系统',
            //         text: '边部加热改善轧制断带、平整问题',
            //         icon: require("@/assets/images/website/home/img5.png"),
            //         path:'/solution/plate-type'
            //     },
            //     {
            //         name: '供应链协同系统',
            //         text: '向企业提供备件交易和共享，促进上下游实物资源和制造能力共享对接',
            //         icon: require("@/assets/images/website/home/img6.png"),
            //         path:'/solution/industrial-internet'
            //     },
            // ]
            planList: [
                {
                    name: '智能工厂整体解决方案',
                    text: '提供完整建设智能工厂的解决方案，从可研、整体设计到落地实施',
                    icon: require("@/assets/images/website/home/img1.png"),
                    path: '/solution/intelligent-factory'
                },
                {
                    name: '数字化工厂解决方案',
                    text: '提供基础网络建设及安防监控网络建设、数据中心机房建设、集控中心建设，打造工厂的数字化、信息化',
                    icon: require("@/assets/images/website/home/img2.png"),
                    path: '/solution/digital-factory'
                },
                {
                    name: '有色金属加工MES系统',
                    text: '为有色金属加工企业提供MES生产制造执行系统 为有色金属装备制造企业提供全方面生产管理解决方案',
                    icon: require("@/assets/images/website/home/img3.png"),
                    path: '/solution/mes-system'
                },
                {
                    name: '信息化辅助系统',
                    text: '为有色金属加工企业提供全流程质量检测、判定与管理一体化解决方案',
                    icon: require("@/assets/images/website/home/img4.png"),
                    path: '/solution/information-system'
                },
                {
                    name: '物流管理系统',
                    text: '从有色金属加工物料、订单、库存、生产、出入库等数据统计与管理',
                    icon: require("@/assets/images/website/home/img5.png"),
                    path: '/solution/logistics-management'
                },
                {
                    name: '工业互联网+AI安全管控系统',
                    text: '对不安全行为进行管控，实现双重信息预防及隐患排查，预防安全事故',
                    icon: require("@/assets/images/website/home/img6.png"),
                    path: '/solution/safety-control'
                },
            ]
        }
    },
    methods: {
        moreNews() {
            this.$router.push('/solution')
        }
    },
}
</script>
<style lang="less" escape>
.home-plan {
    width: 100%;
    padding-top: 63px;
    padding-bottom: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #FFFFFF;

    .plan-title {
        font-family: PingFangSC-Regular;
        font-size: 36px;
        color: #2A313B;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        margin-bottom: 9px
    }

    .plan-more {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #005FE1;
        text-align: center;
        font-weight: 400;
        margin-bottom: 48px;
        cursor: pointer;

        .el-icon-arrow-right {
            font-weight: bold;
        }
    }

    .plan-content {
        width: 1280px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .plan-item {
            width: 413px;
            height: 220px;
            padding: 25px;
            margin-bottom: 22px;
            background: linear-gradient(180deg, #F4F5F8 2%, #FFFFFF 100%);
            box-shadow: 8px 8px 20px 0px rgba(0, 0, 0, 0.04), -8px -8px 20px 0px rgba(0, 0, 0, 0.02);
            border: 2px solid #FFFFFF;
            position: relative;
            cursor: pointer;

            &:hover {
                background: linear-gradient(177deg, #E3EAF3 0%, #F9FAFC 100%);
                box-shadow: inset 3px 3px 15px 0px #E3E9F3;

                .detail {
                    display: block
                }
            }

            .name {
                font-family: PingFangSC-Medium;
                font-size: 20px;
                color: #293341;
                letter-spacing: 0;
                font-weight: 500;
                margin-bottom: 12px;
            }

            .text {
                width: 267px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #293341;
                text-align: justify;
                line-height: 22px;
                font-weight: 400;
                margin-bottom: 8px;
            }

            .detail {
                width: 86px;
                height: 33px;
                background: #005FE1;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #FFFFFF;
                text-align: center;
                font-weight: 400;
                line-height: 33px;
                display: none;
            }

            img {
                width: 100px;
                position: absolute;
                right: 25px;
                bottom: 15px;
            }
        }
    }
}
</style>